import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const SharePoint = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle
      id="sharepoint_group_2_"
      fill="hsl(from hsl(182 96% 27%) h s 34%)"
      cx="12.1"
      cy="7.6"
      r="6.2"
    />
    <circle
      id="sharepoint_group"
      fill="hsl(from hsl(182 96% 27%) h s 51%)"
      cx="17.3"
      cy="13.3"
      r="5.7"
    />
    <circle
      id="sharepoint_group_1_"
      fill="hsl(from hsl(182 96% 27%) h s 66%)"
      cx="12.9"
      cy="18.7"
      r="4.4"
    />
    <path
      id="sharepoint_group_4_"
      opacity="0.1"
      d="M13.1,7V18c0,0.4-0.2,0.7-0.6,0.9c-0.1,0-0.2,0.1-0.4,0.1H8.5c0-0.1,0-0.2,0-0.3
	c0-0.1,0-0.2,0-0.3c0.1-1.7,1.1-3.1,2.6-3.8v-1C7.7,13.2,5.4,10,6,6.6c0,0,0,0,0-0.1C6,6.4,6,6.2,6.1,6h6.1C12.7,6,13.1,6.4,13.1,7z
	"
    />
    <path
      id="sharepoint_group_5_"
      opacity="0.2"
      d="M11.7,6.5H6c-0.6,3.4,1.7,6.6,5.1,7.2c0.1,0,0.2,0,0.3,0c-1.6,0.8-2.8,2.9-2.9,4.7
	c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.2,0,0.3,0.1,0.5h3.1c0.4,0,0.7-0.2,0.9-0.6c0-0.1,0.1-0.2,0.1-0.4V7.5
	C12.6,7,12.2,6.5,11.7,6.5z"
    />
    <path
      id="sharepoint_group_6_"
      opacity="0.2"
      d="M11.7,6.5H6c-0.6,3.4,1.7,6.6,5.1,7.2c0.1,0,0.1,0,0.2,0c-1.6,0.8-2.7,3-2.8,4.7h3.2
	c0.5,0,0.9-0.4,0.9-0.9v-10C12.6,7,12.2,6.5,11.7,6.5z"
    />
    <path
      id="sharepoint_group_7_"
      opacity="0.2"
      d="M11.2,6.5H6c-0.5,3.2,1.5,6.3,4.6,7.1c-1.2,1.4-1.9,3.1-2.1,4.9h2.7c0.5,0,0.9-0.4,0.9-0.9v-10
	C12.1,6.9,11.7,6.5,11.2,6.5z"
    />
    <linearGradient
      id="sharepoint_group_10_"
      gradientUnits="userSpaceOnUse"
      x1="2.6922"
      y1="-1832.2169"
      x2="10.129"
      y2="-1819.3367"
      gradientTransform="matrix(1 0 0 1 0 1838)"
    >
      <stop
        offset="1.076350e-03"
        stopColor="hsl(from hsl(182 96% 27%) h s 45%)"
      />
      <stop offset="0.5011" stopColor="hsl(from hsl(182 96% 27%) h s 42%)" />
      <stop offset="1" stopColor="hsl(from hsl(182 96% 27%) h s 35%)" />
    </linearGradient>
    <path
      id="sharepoint_group_8_"
      fill="url(#sharepoint_group_10_)"
      d="M1.7,6.5h9.5c0.5,0,0.9,0.4,0.9,0.9V17c0,0.5-0.4,0.9-0.9,0.9H1.7c-0.5,0-0.9-0.4-0.9-0.9V7.5
	C0.7,7,1.1,6.5,1.7,6.5z"
    />
    <path
      id="sharepoint_group_9_"
      fill="hsl(from hsl(182 96% 27%) h s 100%)"
      d="M5,12.1c-0.2-0.1-0.4-0.3-0.5-0.6c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.4,0.1-0.7,0.4-1
	c0.3-0.3,0.6-0.5,0.9-0.6C5.9,9,6.4,8.9,6.8,8.9c0.6,0,1.1,0.1,1.7,0.2v1.2C8.2,10.2,8,10.1,7.7,10C7.4,10,7.1,9.9,6.8,9.9
	c-0.3,0-0.6,0.1-0.9,0.2c-0.2,0.1-0.4,0.3-0.4,0.6c0,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.1,0.4,0.2,0.8,0.3
	c0,0,0.1,0,0.1,0c0.3,0.1,0.7,0.3,1,0.5c0.2,0.1,0.4,0.3,0.6,0.6c0.1,0.3,0.2,0.6,0.2,0.9c0,0.4-0.1,0.8-0.3,1.1
	c-0.2,0.3-0.5,0.5-0.9,0.6c-0.4,0.1-0.8,0.2-1.3,0.2c-0.4,0-0.8,0-1.1-0.1c-0.3-0.1-0.6-0.1-0.9-0.3v-1.3c0.3,0.2,0.6,0.4,0.9,0.4
	c0.3,0.1,0.7,0.2,1,0.2c0.3,0,0.6,0,0.9-0.2c0.2-0.1,0.3-0.3,0.3-0.6c0-0.2-0.1-0.3-0.2-0.4C7.1,13.2,7,13.1,6.8,13
	c-0.2-0.1-0.5-0.2-0.9-0.4C5.5,12.5,5.2,12.3,5,12.1z"
    />
  </svg>
);
